module.exports = __webpack_public_path__ + "img/nd.c3f218f7.png";